import { render, staticRenderFns } from "./positive.vue?vue&type=template&id=0dd35ece&scoped=true"
import script from "./positive.vue?vue&type=script&lang=js"
export * from "./positive.vue?vue&type=script&lang=js"
import style0 from "./positive.vue?vue&type=style&index=0&id=0dd35ece&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd35ece",
  null
  
)

export default component.exports